import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Input from '../../components/UI/Input';
import Button from '../../components/UI/Button';
import OAuthButtons from '../../components/Auth/OAuthButtons';
import * as validators from '../../utils/validators';
import * as authService from '../../services/authService';

export default function Register() {
	const navigate = useNavigate();
	const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', confirm: '', referralCode: '' });
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);

	function onChange(e) {
		setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
	}

	function validate() {
		const e = {};
		if (!form.name.trim()) e.name = 'Name is required';
		if (!validators.validateEmail(form.email)) e.email = 'Enter a valid email';
		if (!validators.validatePassword(form.password)) e.password = 'Min 8 chars, include a number';
		if (form.password !== form.confirm) e.confirm = 'Passwords do not match';
		setErrors(e);
		return Object.keys(e).length === 0;
	}

	async function onSubmit(e) {
		e.preventDefault();
		if (!validate()) return;
		setLoading(true);
		try {
			await authService.register({
				name: form.name,
				email: form.email,
				phone: form.phone,
				password: form.password,
				referralCode: form.referralCode
			});
			toast.success('Registered! Please verify your email.');
			navigate('/login');
		} catch (err) {
			toast.error(err?.response?.data?.message || 'Registration failed');
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md bg-white shadow rounded-lg p-6">
				<h1 className="text-2xl font-bold text-center">Create your account</h1>
				
				{/* OAuth Buttons */}
				<div className="mt-6">
					<OAuthButtons />
				</div>

				{/* Divider */}
				<div className="relative my-6">
					<div className="absolute inset-0 flex items-center">
						<div className="w-full border-t border-gray-300"></div>
					</div>
					<div className="relative flex justify-center text-sm">
						<span className="px-2 bg-white text-gray-500">Or register with email</span>
					</div>
				</div>

				{/* Email/Password Form */}
				<form className="space-y-4" onSubmit={onSubmit}>
					<Input name="name" label="Name" value={form.name} onChange={onChange} error={errors.name} required />
					<Input name="email" label="Email" value={form.email} onChange={onChange} error={errors.email} required />
					<Input name="phone" label="Phone" value={form.phone} onChange={onChange} />
					<Input name="password" type="password" label="Password" value={form.password} onChange={onChange} error={errors.password} required />
					<Input name="confirm" type="password" label="Confirm Password" value={form.confirm} onChange={onChange} error={errors.confirm} required />
					<Input name="referralCode" label="Referral Code (optional)" value={form.referralCode} onChange={onChange} />
					<Button type="submit" loading={loading} className="w-full">
						Register
					</Button>
				</form>
				<p className="mt-4 text-sm text-center">
					Already have an account?{' '}
					<Link to="/login" className="text-primary-600 hover:underline">
						Login
					</Link>
				</p>
			</div>
		</div>
	);
}


